import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Pill } from 'apps/sigma2-ui/src/components/Pill';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

interface TestResultsCountProps {
  totalTestsCount: number;
  passedTestsCount: number;
  failedTestsCount: number;
  incompleteTestsCount: number;
  selectedTreatmentCount: number;
}

export const TestResultsPills = ({
  totalTestsCount,
  passedTestsCount,
  failedTestsCount,
  selectedTreatmentCount,
}: TestResultsCountProps) => {
  const allTestsPassed = passedTestsCount === totalTestsCount;
  const language = useLanguage();

  return (
    <ul className="flex">
      {allTestsPassed ? (
        <li className="mr-2">
          <Pill bgClassName="bg-green-100">
            <S2Typography
              translatedContent={language.testStatusAllPassed()}
              variant="small-label-alt"
              textColorVariant="green-800"
            />
          </Pill>
        </li>
      ) : failedTestsCount === 0 ? (
        <li className="mr-2">
          <Pill bgClassName="bg-gray-200">
            <S2Typography
              translatedContent={language.testStatusIncomplete()}
              variant="small-label-alt"
              textColorVariant="gray-800"
            />
          </Pill>
        </li>
      ) : (
        <li className="mr-2">
          <Pill bgClassName="bg-red-100">
            <S2Typography
              translatedContent={language.treatmentSelectionTestsFailed({
                failedTestsCount,
                totalTestsCount,
              })}
              variant="small-label-alt"
              textColorVariant="red-800"
            />
          </Pill>
        </li>
      )}
      {selectedTreatmentCount > 0 && (
        <li>
          <Pill bgClassName="bg-violet-100">
            <S2Typography
              translatedContent={
                selectedTreatmentCount === 1
                  ? language.treatmentSelectionCountSingular({
                      count: selectedTreatmentCount,
                    })
                  : language.treatmentSelectionCountPlural({
                      count: selectedTreatmentCount,
                    })
              }
              variant="small-label-alt"
              textColorVariant="violet-800"
            />
          </Pill>
        </li>
      )}
    </ul>
  );
};
